// extracted by mini-css-extract-plugin
export default {"imgFadeOpacity":"Image_imgFadeOpacity__j4AUR","fadeIn":"Image_fadeIn__mnvia"};